import jQuery from "jquery";

interface AlertOptions {
    title?: string,
    message?: string,
    messageHTML?: string,
    callback?: () => void
}

interface ConfirmationOptions {
    title?: string,
    message?: string,
    messageHTML?: string,
    options: string[]
}

export default class Alerts {

    static alert(data: string | AlertOptions) {

        const opts = (typeof data === "string") ? { message: data } : data;

        if (! opts.title) {
            opts.title = "";
        }

        const html = opts.message || opts.messageHTML || "";

        let elt = jQuery("#Alerts");
        if (elt.length == 0) {
            elt = jQuery("<div id='Alerts'><div class='mask'></div><div class='modal'><div class='close'><i class='fa-solid fa-xmark fa-fw'></i></div><div class='body'></div><div>");
            jQuery("body").append((elt));

            function dismiss() {
                elt.hide();
                opts.callback && opts.callback();
            }

            elt.on("click", ".mask", dismiss);
            elt.on("click", ".modal .close", dismiss);
        }
        elt.find(".body").html(html);
        elt.show();
    }

    static async confirmation(opts: ConfirmationOptions): Promise<string> {

        jQuery("#Confirmation").remove();

        return new Promise((resolve, reject) => {
            let elt = jQuery("#Confirmation");

            function onButton(evt: JQueryEventObject) {
                const selected = jQuery(evt.target).text();
                elt.remove();
                resolve(selected);
            }

            elt = jQuery("<div id='Confirmation'><div class='mask'></div><div class='modal'><div class='body'></div><div class='footer'></div></div>");
            jQuery("body").append((elt));

            for (const option of opts.options) {
                jQuery("<button>").addClass("option").text(option).appendTo(elt.find(".footer"));
            }

            elt.on("click", ".modal .footer button", onButton);

            const html = opts.message || opts.messageHTML || "";

            elt.find(".body").html(html);
            elt.show();

        });

    }

}
